import { createSlice } from '@reduxjs/toolkit';

// Admin Stripe Connect card (Task 6) — mirrors store/colo/coloSlice.js's
// requestStart/requestFailure loading-flag convention.
const initialState = {
  status: null, // { connected, chargesEnabled } once fetched
  isLoading: false,
  error: null
};

const stripeSlice = createSlice({
  name: 'stripe',
  initialState,
  reducers: {
    requestStart: state => {
      state.isLoading = true;
      state.error = null;
    },
    requestFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    fetchStatusSuccess: (state, action) => {
      state.status = action.payload;
      state.isLoading = false;
    },
    // Local optimistic update once stripe/disconnect succeeds — same "mutate the slice from the
    // known result, no extra round trip" convention as coloSlice's updateSourceSuccess.
    disconnectSuccess: state => {
      state.status = { connected: false, chargesEnabled: false };
      state.isLoading = false;
    }
  }
});

export const {
  requestStart,
  requestFailure,
  fetchStatusSuccess,
  disconnectSuccess
} = stripeSlice.actions;

export default stripeSlice.reducer;
